import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { SlidersHorizontal, Hash } from 'lucide-react';
import WidgetPublishBar from './WidgetPublishBar';
import { SectionCard, FieldHelp, ToggleRow, setField } from './SettingsUI';
import { isQuoteChatUiEnabled } from '../../utils/featureFlags';

const BasicSetupTab = ({ form, setForm, onNavigate }) => {
  const { t } = useTranslation();
  return (
    <div className="q2c-settings-compact">
      <WidgetPublishBar onNavigate={onNavigate} />
      <div className="row g-3">
        <div className="col-lg-7">
          <SectionCard title={t('settings.basicSetup.quoteConfig')} icon={SlidersHorizontal}>
            <div className="q2c-toggle-grid">
              <ToggleRow
                id="toggle-enableQuotes"
                label={t('settings.basicSetup.enableQuotes')}
                help={t('settings.basicSetup.enableQuotesHelp')}
                checked={form.enableQuotes}
                onChange={(v) => setField(setForm, 'enableQuotes', v)}
              />
              <ToggleRow
                id="toggle-hideAllPrices"
                label={t('settings.basicSetup.hideAllPrices')}
                help={t('settings.basicSetup.hideAllPricesHelp')}
                checked={form.hideAllPrices}
                onChange={(v) => setField(setForm, 'hideAllPrices', v)}
              />
              <ToggleRow
                id="toggle-hideZeroPrice"
                label={t('settings.basicSetup.hideZeroPrice')}
                help={t('settings.basicSetup.hideZeroPriceHelp')}
                checked={form.hideZeroPrice}
                onChange={(v) => setField(setForm, 'hideZeroPrice', v)}
              />
              {isQuoteChatUiEnabled() ? (
                <ToggleRow
                  id="toggle-quoteChatEnabled"
                  label={t('settings.basicSetup.quoteChat')}
                  help={t('settings.basicSetup.quoteChatHelp')}
                  checked={form.quoteChatEnabled}
                  onChange={(v) => setField(setForm, 'quoteChatEnabled', v)}
                />
              ) : null}
            </div>
          </SectionCard>
        </div>

        <div className="col-lg-5">
          <SectionCard title={t('settings.basicSetup.quoteNumbering')} icon={Hash}>
            <div className="row g-2">
              <div className="col-sm-6">
                <FieldHelp
                  label={t('settings.basicSetup.quotePrefix')}
                  help={t('settings.basicSetup.quotePrefixHelp')}
                >
                  <Form.Control
                    size="sm"
                    value={form.quotePrefix || ''}
                    onChange={(e) => setField(setForm, 'quotePrefix', e.target.value)}
                    placeholder="Q-"
                  />
                </FieldHelp>
              </div>
              <div className="col-sm-6">
                <FieldHelp
                  label={t('settings.basicSetup.idIncrement')}
                  help={t('settings.basicSetup.idIncrementHelp')}
                >
                  <Form.Control
                    size="sm"
                    type="number"
                    min="1"
                    value={form.quoteIdIncrement ?? 1}
                    onChange={(e) =>
                      setField(setForm, 'quoteIdIncrement', parseInt(e.target.value, 10) || 1)
                    }
                  />
                </FieldHelp>
              </div>
            </div>
          </SectionCard>
        </div>
      </div>
    </div>
  );
};

export default BasicSetupTab;
